import React from 'react';
import AccountSearch from './AccountSearch';

/**
 * Banda azul oscuro con el buscador (estilo "Classic Explorer").
 *  - hero: portada, con título y espacio inferior para que las tarjetas se solapen
 *  - compacta: resto de páginas
 */
const SearchBand = ({ hero = false, title }) => (
  <section className="bg-navy text-white">
    <div className={`page-container ${hero ? 'pt-8 sm:pt-10 pb-24' : 'py-4'}`}>
      {hero && title && <h1 className="m-0 mb-4 text-[22px] font-semibold">{title}</h1>}
      <AccountSearch variant={hero ? 'hero' : 'compact'} />
    </div>
  </section>
);

export default SearchBand;
